/**
 * Bloqueo del scroll de la página (`overflow: hidden` en `documentElement`)
 * compartido entre todos los overlays que lo necesitan (menú del header,
 * buscador, `LoadingOverlay`).
 *
 * Lleva un contador en vez del patrón «guardo el valor previo y lo restauro»:
 * con ese patrón, dos bloqueos solapados se pisaban. P. ej. clicar una card de
 * «Productos más buscados» montaba el `LoadingOverlay` de navegación mientras
 * el buscador aún tenía el scroll bloqueado (cierra tras su transición); el
 * overlay guardaba `hidden` como valor previo y lo restauraba al terminar la
 * navegación, dejando la PDP sin scroll.
 *
 * Devuelve la función de liberación; es idempotente, así que llamarla más de
 * una vez no descuadra el contador.
 */
let locks = 0

export function lockDocumentScroll(): () => void {
  const root = document.documentElement
  locks += 1
  if (locks === 1) root.style.overflow = 'hidden'

  let released = false
  return () => {
    if (released) return
    released = true
    locks -= 1
    if (locks === 0) root.style.overflow = ''
  }
}
